<template>
  <div class="workorders-main-wrapper">
    <div>
    </div>
    <v-container grid-list-lg id="workorders-toggle-filters" class="workorders-task-wrapper toggleOn-filters">
      <v-layout row wrap class="workorders-col-wrapper">
        <v-flex xs12 sm12 md4 lg4 xl3 class="workorders-col1-wrapper" @scroll="onScroll">
          <task-list></task-list>
        </v-flex>
        <v-flex xs12 sm12 md8 lg8 xl9 class="workorders-col2-wrapper">
          <detail class="detail-view above" v-if="task" ></detail>
          <map-view class="map-view"></map-view>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import TaskList from '@/components/workorders/TaskList'
import Detail from '@/components/workorders/Detail'
import MapView from '@/components/workorders/MapView'
export default {
  name: 'WorkOrderList',
  components: {
    TaskList,
    Detail,
    MapView
    },
    mounted () {

    let width = window.innerWidth
      if (width < 959) {
       let toggleScheduleFilters = document.getElementById('workorders-toggle-filters')
      if (!toggleScheduleFilters.classList.contains('toggleOff-filters')) {
        this.toggleFilters()
      } 
    }
  },
  methods: {
    ...mapActions({
      loadWorkOrderTasks: 'workOrderTask/getTasks'
    }),
    onScroll ({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight) {
        if ((this.taskPagination.pageIndex * this.taskPagination.pageSize) < this.taskPagination.count) {
          let search = {}
          search = this.searchObject
          let newPage = this.taskPagination.pageIndex + 1
          let searchReturn = { pageIndex: newPage }
          search.searchReturn = searchReturn
          // search.pageIndex = newPage
          this.loadWorkOrderTasks(search)
        }
      }
    },
    toggleFilters () {
      this.toggleFilterClasses()
      this.filterPanel = this.filterPanel !== 0 ? 0 : []
    },
    toggleFilterClasses () {
      let toggleWorkOrderFilters = document.getElementById('workorders-toggle-filters')
      if (toggleWorkOrderFilters) {
        toggleWorkOrderFilters.classList.toggle('toggleOff-filters')
      }
    }
  },
  computed: {
    ...mapGetters({
      task: 'workOrderTask/selectedTask',
      taskPagination: 'workOrderTask/taskPagination',
      searchObject: 'workOrderTask/searchObject'
    })
  }
}
</script>

<style scoped>
  .above {
      z-index: 200;
  }
  .workorders-main-wrapper {
    position: fixed;
    overflow: hidden;
    height: 100%;
    left: 256px;
    right: 0;
  }
  .workorders-task-wrapper {
    max-width: 100% !important;
    min-width: 100% !important;
    padding: 0 0 0 8px !important;
  }
  .toggleOn-filters {
    height: calc(100% - 183px);
  }
  .toggleOff-filters {
    height: calc(100% - 71px) !important;
  }
  .workorders-col-wrapper {
    height: 100%;
    padding-top: 0 !important;
    margin: 0 !important;
  }
  .workorders-col1-wrapper {
    height: 100%;
    overflow-y: scroll;
  }
  .workorders-col2-wrapper {
    height: 100%;
    padding: 0 0 0 8px !important;
  }
  .workorders-col2-wrapper .container.grid-list-lg .layout .flex {
    padding: 0 !important;
  }
  @media only screen and (max-width: 1263px) {
    .workorders-main-wrapper {
      left: 0;
    }
    .toggleOn-filters {
      height: calc(100% - 247px);
    }
    .toggleOff-filters {
      height: calc(100% - 135px) !important;
    }
  }
  @media only screen and (max-width: 959px) {
    .toggleOn-filters {
      height: calc(100% - 242px);
    }
    .toggleOff-filters {
      height: calc(100% - 129px) !important;
    }
    .map-view {
      display: none;
    }
    .workorders-task-wrapper {
      padding: 0 8px !important;
      position: relative;
      overflow-y: scroll !important;
    }
    .workorders-col2-wrapper {
      height: 0;
    }
    .detail-view {
      position: absolute;
      top: 0;
      bottom: 50px;
      right: 0;
      left: 0;
    }
  }
  @media only screen and (max-width: 800px) {
    .toggleOn-filters {
      height: calc(100% - 408px);
    }
    .toggleOff-filters {
      height: calc(100% - 129px) !important;
    }
  }
  @media only screen and (max-width: 540px) {
    .toggleOn-filters {
      height: calc(100% - 449px);
    }
    .toggleOff-filters {
      height: calc(100% - 168px) !important;
    }
  }
</style>
